import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { productosData } from '../data/productos';
import { FaWhatsapp, FaArrowLeft, FaInfoCircle } from 'react-icons/fa';
import './DetalleProducto.css';

const DetalleProducto = () => {
  const { id } = useParams();
  const producto = productosData.find(p => p.id === id);

  //UseEffect para actualizar la página y mandar a la parte superior
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]); // El [id] hace que se ejecute cada vez que el ID cambie

  // Estado para guardar la opción de tamaño seleccionada (por defecto elegimos la primera)
  const [opcionElegida, setOpcionElegida] = useState(producto?.opciones?.[0] || null);

  if (!producto) {
    return (
      <div className="producto-no-encontrado">
        <h2>Producto no encontrado</h2>
        <Link to="/" className="btn-volver">Volver al inicio</Link>
      </div>
    );
  }

  // Formateador de moneda para que se vea lindo (ej: $ 3.650,00)
  const formatearPrecio = (precio) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS'
    }).format(precio);
  };

  // El mensaje de WhatsApp ahora incluye el tamaño específico
  const numeroWhatsapp = "5492995343092"; 
  const mensajeDefault = `¡Hola! Me interesa llevar una ${opcionElegida?.nombre} de ${producto.nombre}. ¿Cómo coordinamos el pago y envío?`;
  const linkWhatsapp = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(mensajeDefault)}`;

  return (
    <div className="detalle-container">
      <Link to="/productos" className="btn-volver"><FaArrowLeft /> Volver al catálogo</Link>

      <div className="detalle-content">
        <div className="detalle-imagen-izq">
          <img 
            src={producto.imagen} 
            alt={producto.nombre} 
            className="card-image" 
            loading="lazy" 
            />
          {/* Nota aclaratoria debajo de la imagen */}
          <div className="nota-aclaratoria">
            <p><FaInfoCircle /> <strong>¡Información sobre el peso!</strong><br/>
            El peso real del queso puede diferir ligeramente. Nos aseguramos de que el valor sea justo y proporcional al peso real.</p>
          </div>
        </div>
        
        <div className="detalle-info-der">
          <h1>{producto.nombre}</h1>
          
          {/* Precio dinámico principal */}
          <div className="precio-destacado">
            {opcionElegida ? formatearPrecio(opcionElegida.precio) : 'Consultar precio'}
          </div>

          <p className="detalle-descripcion">{producto.descripcion}</p>
          
          {/* Selector de Tamaños */}
          {producto.opciones && (
            <div className="selector-tamanos">
              <h3>Elegí el tamaño:</h3>
              <div className="opciones-grid">
                {producto.opciones.map((opcion) => (
                  <div 
                    key={opcion.id}
                    // Le agregamos la clase 'seleccionado' si coincide con el estado actual
                    className={`opcion-card ${opcionElegida.id === opcion.id ? 'seleccionado' : ''}`}
                    onClick={() => setOpcionElegida(opcion)}
                  >
                    <span className="opcion-nombre">{opcion.nombre}</span>
                    <span className="opcion-peso">({opcion.peso})</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          <a href={linkWhatsapp} target="_blank" rel="noopener noreferrer" className="btn-comprar-wa grande">
            <FaWhatsapp /> Pedir por WhatsApp
          </a>
            <p><FaInfoCircle /> <strong> Envíos</strong><br/>
            Los productos no cuentan con envío. Para la información del retiro de los productos contacte vía WhatsApp.</p>

          {/* Acordeones nativos para Información Técnica */}
          <div className="info-tecnica-acordeones">
            <details>
              <summary>Usos recomendados</summary>
              <p>{producto.usosRecomendados}</p>
            </details>
            <details>
              <summary>Almacenamiento</summary>
              <p>{producto.almacenamiento}</p>
            </details>
          </div>

        </div>
      </div>
    </div>
  );
};

export default DetalleProducto;